import { render, staticRenderFns } from "./CDWheelCenter.vue?vue&type=template&id=544300a0&scoped=true"
import script from "./CDWheelCenter.vue?vue&type=script&lang=ts"
export * from "./CDWheelCenter.vue?vue&type=script&lang=ts"
import style0 from "./CDWheelCenter.vue?vue&type=style&index=0&id=544300a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544300a0",
  null
  
)

export default component.exports